(function() { module.exports = window["go"]; }());